import React, {Component} from 'react';
import {numberFormat} from '../utils/number';
import {cloneDeep, isEqual, orderBy} from 'lodash';
import SortableTableHeading from './SortableTableHeading';

export default class CompetitionsByDepartment extends Component {
    constructor(props) {
        super(props);

        const newData = cloneDeep(props.data);

        this.state = {
            data: newData,
            sortField: 'budget_sum',
            sortDirection: 'desc',
        };

        this.onTableHeadingClick = this.onTableHeadingClick.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (isEqual(this.props.data, nextProps.data)) {
            return;
        }
        const newData = cloneDeep(nextProps.data);
        this.setState({data: newData});
    }

    onTableHeadingClick(sortField, sortDirection) {
        const newData = cloneDeep(this.state.data);
        const sortedData = orderBy(newData, [sortField], [sortDirection]);
        this.setState({sortField, sortDirection, data: sortedData});
    }

    render() {
        const {data} = this.state;

        return (
            <div className="x_panel">
                <div className="x_title">
                    <h2>
                        <i className="fa fa-angle-right"></i> {window.__js_dashboard.competitions_by_department}
                    </h2>
                    <div className="clearfix"></div>
                </div>
                <div className="x_content">
                    <div className="table-responsive">
                        <table className="table table-hover table-striped table-bordered">
                            <thead>
                            <tr>
                                <th>Α/Α</th>
                                <th>{window.__js_dashboard.department}</th>
                                <SortableTableHeading
                                    isSortEnabled={this.state.sortField === 'competitions_count'}
                                    sortDirection={this.state.sortDirection}
                                    onClick={(sortDirection) => this.onTableHeadingClick('competitions_count', sortDirection)}
                                >
                                    {window.__js_dashboard.competitions_count}
                                </SortableTableHeading>
                                <SortableTableHeading
                                    isSortEnabled={this.state.sortField === 'budget_sum'}
                                    sortDirection={this.state.sortDirection}
                                    onClick={(sortDirection) => this.onTableHeadingClick('budget_sum', sortDirection)}
                                >
                                    {window.__js_dashboard.total_budget}
                                </SortableTableHeading>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                data.length === 0
                                    ? <tr>
                                        <td colSpan={4}>
                                            <em>{window.__js_dashboard.no_search_results}</em>
                                        </td>
                                    </tr>
                                    : null
                            }
                            {
                                data.map((item, index) => {
                                    return (
                                        <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>{item.name}</td>
                                            <td>{numberFormat(item.competitions_count, 0, '', '.')}</td>
                                            <td>
                                                {numberFormat(item.budget_sum, 2, ',', '.')} €
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}